module.exports = __webpack_public_path__ + "img/07_02.42b568b7.gif";